import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface CompleteTaskResponse {
  task: {
    complete: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class CompleteTaskService {
  constructor(private apollo: Apollo) {}

  complete(
    taskId,
    mutation: DocumentNode
  ): Observable<FetchResult<CompleteTaskResponse>> {
    return this.apollo.mutate<CompleteTaskResponse>({
      mutation: mutation,
      variables: {
        taskId,
      },
    });
  }
}
